.Input3620606023__root {
  -st-states: size(enum(small, medium, large)), disabled, status(enum(warning, success, error));
  --Input3620606023-inner-border-color: #a8caff;
  box-shadow: inset 0 0 0 1px var(--Input3620606023-inner-border-color);
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.Input3620606023__input {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-medium, 530);
  -webkit-font-smoothing: antialiased;
  border: none;
  width: 100%;
  padding: 0;
  text-overflow: ellipsis;
}

/* Hover */
.Input3620606023__root:hover:not(:focus):not(.Input3620606023--disabled),
.Input3620606023__root:hover:not(:focus):not(.Input3620606023--disabled) .Input3620606023__input {
  background-color: #d6e6fe;
}

/* Focus */
.Input3620606023__input:focus {
    outline: none;
}

.Input3620606023__root:focus-within {
    outline: none;
    --Input3620606023-inner-border-color: #116dff;
}

/* Size */
.Input3620606023__root.Input3620606023---size-5-small {
  height: 24px;
  padding: 3px 12px;
}

.Input3620606023__root.Input3620606023---size-5-small .Input3620606023__input {
  font-size: 14px;
  line-height: 18px;
}

.Input3620606023__root.Input3620606023---size-6-medium {
  height: 30px;
  padding: 6px 12px;
}

.Input3620606023__root.Input3620606023---size-6-medium .Input3620606023__input {
  font-size: 16px;
  line-height: 24px;
}

.Input3620606023__root.Input3620606023---size-5-large {
  height: 36px;
  padding: 6px 12px;
}

.Input3620606023__root.Input3620606023---size-5-large .Input3620606023__input {
  font-size: 16px;
  line-height: 24px;
}

/* Affix */
.Input3620606023__prefix {
  -st-extends: Text;
  padding-right: 6px;
}

.Input3620606023__suffix {
  -st-extends: Text;
  padding-left: 6px;
}

.Input3620606023__prefixNode {
  padding-right: 6px;
}

.Input3620606023__suffixNode {
  padding-left: 6px;
}

.Input3620606023__prefixNode svg,
.Input3620606023__suffixNode svg {
  fill: #868aa5;
  display: flex;
  justify-content: center;
}

.Input3620606023__prefix.Text899316905---skin-8-standard,
.Input3620606023__suffix.Text899316905---skin-8-standard {
  color: #868aa5;
}

/* Status */
.Input3620606023__icon {
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.Input3620606023__root .Input3620606023__icon {
  margin: 0 0 0 6px;
}

.Input3620606023__root.Input3620606023---status-7-warning .Input3620606023__icon {
  color: #ffb700;
}

.Input3620606023__root.Input3620606023---status-7-warning {
  --Input3620606023-inner-border-color: #ffb700;
}

.Input3620606023__root.Input3620606023---status-5-error .Input3620606023__icon {
  color: #e62214;
}

.Input3620606023__root.Input3620606023---status-5-error {
  --Input3620606023-inner-border-color: #e62214;
}

.Input3620606023__root.Input3620606023---status-7-success .Input3620606023__icon {
  color: #25a55a;
}

.Input3620606023__successIcon svg {
  fill: #25a55a;
}

/* Disabled */
.Input3620606023__root.Input3620606023--disabled {
  --Input3620606023-inner-border-color: #d5d5d5;
}

.Input3620606023__root.Input3620606023--disabled .Input3620606023__input {
  color: #898989;
  background-color: #fff;
}

.Input3620606023__root.Input3620606023--disabled .Input3620606023__icon {
  fill: #898989;
}

.Input3620606023__root.Input3620606023--disabled .Input3620606023__prefixNode svg,
.Input3620606023__root.Input3620606023--disabled .Input3620606023__suffixNode svg {
  fill: #898989;
}

/* st-namespace-reference="../../../../src/atoms/Input/Input.st.css" */